import { createPortal } from 'react-dom';
import SelcetBranch from 'pages/SuperAdmin/SelcetBranch/SelcetBranch';

const SelectBranchModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-600 bg-opacity-50">
      <div className="mx-auto w-11/12 max-w-md rounded bg-white p-6 shadow-lg">
        <h3 className="mb-4 text-lg font-bold">Select a Branch</h3>
        <p className="mb-6">Please select a branch to continue.</p>
        {/* Render the SelcetBranch component inside the modal */}
        <SelcetBranch onClose={onClose} />
        {/* <div className="mt-4 flex justify-end">
          <button className="rounded bg-gray-300 p-2" onClick={onClose}>
            Close
          </button>
        </div> */}
      </div>
    </div>,
    document.body
  );
};

export default SelectBranchModal;
